import styled from 'styled-components';
import { colors } from '../../../../../theme/theme';



export const ListContent = styled.div`  
    overflow-y: scroll;
    height: calc(100vh - 15em); 
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;


export const ObjectList = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(380px, 0.4fr));
    grid-column-gap: 16px;
    grid-row-gap: 16px;

    @media only screen and (max-width: 1330px) { 
        grid-template-columns: repeat(auto-fit, minmax(380px, 0.4fr));
    }
`;

export const NotFound = styled.div`  
    width: 100%;
    height: calc(100vh - 15em); 
    text-align: center;
    vertical-align: center;
    font-size: 24px;
    margin-top: 25vh;
    color: ${colors.greyscale.grey};

    .iconNotFound{
        font-size: 14vh;
        color: ${colors.greyscale.grey2};
    }
`;